function gaTrack(...args) {
  if (window.ga) {
    window.setTimeout(function () {
      window.ga.apply(window.ga, args);
      //console.log('ANALTICS: ', args);
    }, 0);
  }
}

module.exports = {
  pageView: function (page, title) {
    gaTrack("send", "pageview", "/weyrich" + page);
  },
  changeDate: function (filters) {
    for (var key in filters) {
      // skip loop if the property is from prototype
      if (!filters.hasOwnProperty(key)) continue;
      gaTrack("send", "event", "find-car", "filter-used", key);
    }
  },
  event: function (...args) {
    gaTrack(...["send", "event"].concat(args));
  },
  ec: function (type, product) {
    gaTrack("ec:" + type, product);
  },
  ecAction: function (type, params) {
    gaTrack("ec:setAction", type, params);
  },
};



// WEBPACK FOOTER //
// ./src/utils/tracking.js